import { useTranslation } from "react-i18next";
import {
  Form,
  Input,
  LastNameInput,
  Row,
  SignupField,
  StyledCompanyIcon,
  StyledInput,
  StyledLockIcon,
  StyledMailIcon,
  StyledUserIcon,
  StyledVisibility,
  StyledVisibilityOff,
} from "./SignupPage.style";
import { isValidEmail, isValidPassword } from "../../../utils/utils";
import Icon from "../../../components/Icon";

const SignUpFormComponent = ({
  companyName,
  ar,
  inputBackgroundColorWhite,
  setCompanyName,
  setFirstName,
  firstName,
  lastName,
  setLastName,
  checkValidation,
  email,
  setEmail,
  visibility,
  visibility2,
  confirmPassword,
  password,
  setPassword,
  setConfirmPassword,
  setVisibility,
  setVisibility2,
  fullName,
  setFullName,
  hideFirstAndLastName,
  showFullName,
  inviteToken,
}) => {
  const { t } = useTranslation();

  const handleVisibilityToggle = () => {
    setVisibility(!visibility);
  };

  const handleVisibilityToggle2 = () => {
    setVisibility2(!visibility2);
  };
  return (
    <Form>
      {!inviteToken && (
        <SignupField>
          <Icon
            icon={<StyledCompanyIcon className="login__icon" />}
            selectedLocale={ar}
          />

          <Input
            $bg={inputBackgroundColorWhite}
            $ar={ar}
            type="text"
            $error={checkValidation && !companyName}
            placeholder={t("company-name")}
            value={companyName}
            onChange={(e) => {
              const inputValue = e.target.value;
              const transformedValue =
                inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
              setCompanyName(transformedValue);
            }}
          />
        </SignupField>
      )}
      {!hideFirstAndLastName && (
        <Row>
          <SignupField>
            <Icon
              icon={<StyledUserIcon className="login__icon" />}
              selectedLocale={ar}
            />

            <StyledInput
              $bg={inputBackgroundColorWhite}
              $ar={ar}
              $error={checkValidation && !firstName}
              type="text"
              placeholder={t("first-name")}
              value={firstName}
              onChange={(e) => {
                const inputValue = e.target.value;
                const transformedValue =
                  inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                setFirstName(transformedValue);
              }}
            />
          </SignupField>
          <SignupField>
            <LastNameInput
              type="text"
              $bg={inputBackgroundColorWhite}
              $error={checkValidation && !lastName}
              placeholder={t("last-name")}
              value={lastName}
              onChange={(e) => {
                const inputValue = e.target.value;
                const transformedValue =
                  inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
                setLastName(transformedValue);
              }}
            />
          </SignupField>
        </Row>
      )}

      {showFullName && (
        <SignupField>
          <Icon
            icon={<StyledUserIcon className="login__icon" />}
            selectedLocale={ar}
          />

          <Input
            type="text"
            $error={checkValidation && !fullName}
            placeholder={t("full-name")}
            $bg={inputBackgroundColorWhite}
            value={fullName}
            onChange={(e) => {
              const inputValue = e.target.value;
              const transformedValue =
                inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
              setFullName(transformedValue);
            }}
          />
        </SignupField>
      )}
      <SignupField>
        <Icon
          icon={<StyledMailIcon className="login__icon" />}
          selectedLocale={ar}
        />

        <Input
          $bg={inputBackgroundColorWhite}
          $ar={ar}
          $error={checkValidation && (!isValidEmail(email) || !email)}
          type="text"
          placeholder={t("email-address")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </SignupField>
      <SignupField>
        <Icon
          icon={<StyledLockIcon className="login__icon" />}
          selectedLocale={ar}
        />
        <Input
          $ar={ar}
          type={visibility ? "text" : "password"}
          placeholder={t("password")}
          $error={checkValidation && (!isValidPassword(password) || !password)}
          $bg={inputBackgroundColorWhite}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {visibility ? (
          <Icon
            icon={
              <StyledVisibility
                className="login__icon_right"
                onClick={handleVisibilityToggle}
              />
            }
            selectedLocale={ar}
          />
        ) : (
          <Icon
            icon={
              <StyledVisibilityOff
                className="login__icon_right"
                onClick={handleVisibilityToggle}
              />
            }
            selectedLocale={ar}
          />
        )}
      </SignupField>
      <SignupField>
        <Icon
          icon={<StyledLockIcon className="login__icon" />}
          selectedLocale={ar}
        />
        <Input
          $ar={ar}
          type={visibility2 ? "text" : "password"}
          placeholder={t("confirm-password")}
          $bg={inputBackgroundColorWhite}
          $error={
            checkValidation &&
            (!confirmPassword || password !== confirmPassword)
          }
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {visibility2 ? (
          <Icon
            icon={
              <StyledVisibility
                className="login__icon_right"
                onClick={handleVisibilityToggle2}
              />
            }
            selectedLocale={ar}
          />
        ) : (
          <Icon
            icon={
              <StyledVisibilityOff
                className="login__icon_right"
                onClick={handleVisibilityToggle2}
              />
            }
            selectedLocale={ar}
          />
        )}
      </SignupField>
    </Form>
  );
};

export default SignUpFormComponent;
